import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_black_friday_for_pilates_f~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_black_friday_for_pilates_f'
					),
			},
		},
	},
]

export default config
